import React from "react"
import BotaoVoltar from "./common/botaoVoltar";

export default function Ajuda() {

	return (
		<div className="container-fluid">
			<div className="row">
				<div className="col-12">
					<header className="main">
						<h2>DISTVAF - Ajuda</h2>
					</header>
				</div>
			</div>
			<div className="row">
				<div className="col-6">
				</div>
				<div className="col-6">
					<BotaoVoltar />
				</div>
			</div>
			<div className="row">
				<div className="col-12">
					<h2>Introdução</h2>
					<p>Esta aplicação tem o objetivo de realizar a geração e o envio dos arquivos texto com os dados do VAF para as prefeituras, AF&apos;s e ARF&apos;s.</p>
					<h2>Descrição do processo</h2>
					<p>O processo de geração e envio consiste basicamente de duas etapas distintas.</p>
					<p>O usuário deverá verificar com o setor responsável se o arquivo texto com todos os dados já foi gerado e disponibizado no FTP.</p>
					<p>Tendo obtido o nome do arquivo o usuário poderá então escolher a opção <span className="botao">IMPORTAÇÃO</span> na página principal desta aplicação e escolher o tipo do arquivo que será importado, o nome do arquivo que foi fornecido e clicar no botão <span className="botao">IMPORTAR</span>.</p>
					<p>A seguir o usuário poderá passar para a segunda etapa, que consiste no efetivo envio dos arquivos gerados.</p>
					<p>Na tela principal o usuário deverá escolher a opção <span className="botao">ENVIO</span> e ajustar os parâmetros de envio e clicar no botão <span className="botao">ENVIAR ARQUIVOS</span>.</p>
					<h2>Manutenção dos cadastros</h2>
					<p>Caso seja necessário, o usuário poderá fazer alterações, inclusões e exclusões nos cadastros do sistema, que são o seguintes</p>
					<ul>
						<li>Cadastro de prefeituras</li>
						<li>Cadastro de AF&apos;s</li>
						<li>Cadastro de SRF&apos;s</li>
					</ul>
					<p></p>
					<h2>Consulta aos envios realizados</h2>
					<p>Todos os envios são registrados e é pssível realizar consultas por tipo de envio, tipo de destino, destinatário e período do envio.</p>
				</div>
			</div>
		</div>
	)
}
